
import React, { Component } from 'react';
import { connect } from 'react-redux'

import CheckBoxComponent from './CheckBoxComponent';

var translator = require('../../utils/translator/translator');
var controlSettingsUtils = require('../../utils/domain/settings/controlSettingsUtils');


class ControlSettingsView extends Component 
{
    render()
    {
        return <div>
                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return controlSettingsUtils.getSignatureCardAllowed();
                            }}
                            revertValue={()=>
                            {
                                controlSettingsUtils.setSignatureCardAllowed(!controlSettingsUtils.getSignatureCardAllowed());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("signature_card_allowed")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("please_select_this_option_to_allow_customers_to_use_a_credit_card_that_requires_signature_verification")
                            }}>

                        </CheckBoxComponent>
                    </div>
                    
                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return controlSettingsUtils.getAllowOpenItems();
                            }}
                            revertValue={()=>
                            {
                                controlSettingsUtils.setAllowOpenItems(!controlSettingsUtils.getAllowOpenItems());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("open_items")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("by_choosing_this_option_staff_can_place_an_order_for_an_item_that_is_not_listed_in_the_menu")
                            }}>

                        </CheckBoxComponent>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return controlSettingsUtils.getAllowOpenDiscounts();
                            }}
                            revertValue={()=>
                            {
                                controlSettingsUtils.setAllowOpenDiscounts(!controlSettingsUtils.getAllowOpenDiscounts());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("open_discounts")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("by_choosing_this_option_staff_can_enter_discount_amount_manually")
                            }}>

                        </CheckBoxComponent>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return controlSettingsUtils.getLogoutAfterEachOrder();
                            }}
                            revertValue={()=>
                            {
                                controlSettingsUtils.setLogoutAfterEachOrder(!controlSettingsUtils.getLogoutAfterEachOrder());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("logout_after_order")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("by_choosing_this_option_the_system_will_log_out_the_user_as_soon_as_they_place_an_order")
                            }}>

                        </CheckBoxComponent>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return controlSettingsUtils.getLogoutAfterIdle();
                            }}
                            revertValue={()=>
                            {
                                controlSettingsUtils.setLogoutAfterIdle(!controlSettingsUtils.getLogoutAfterIdle());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("logout_on_idle")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("by_choosing_this_option_the_system_will_automatically_log_out_staff_when_it_remains_idle_and_is_not_in_use")
                            }}>

                        </CheckBoxComponent>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return controlSettingsUtils.getAllowAllStorefronts();
                            }}
                            revertValue={()=>
                            {
                                controlSettingsUtils.setAllowAllStorefronts(!controlSettingsUtils.getAllowAllStorefronts());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("allow_all_storefronts")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("select_this_option_to_enable_access_to_all_storefronts")
                            }}>

                        </CheckBoxComponent>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return controlSettingsUtils.getAllowItemsFromMultipleStorefronts();
                            }}
                            revertValue={()=>
                            {
                                controlSettingsUtils.setAllowItemsFromMultipleStorefronts(!controlSettingsUtils.getAllowItemsFromMultipleStorefronts());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("items_from_multiple_storefronts")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("by_selecting_this_option_you_can_add_menu_items_from_multiple_storefronts_to_the_same_order")
                            }}>

                        </CheckBoxComponent>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return controlSettingsUtils.getMandatoryDetailsBeforeOrderDetails();
                            }}
                            revertValue={()=>
                            {
                                controlSettingsUtils.setMandatoryDetailsBeforeOrderDetails(!controlSettingsUtils.getMandatoryDetailsBeforeOrderDetails());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("mandatory_information_prior_to_order_details")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("by_choosing_this_option_the_system_will_request_essential_information_before_the_order_details.")
                            }}>

                        </CheckBoxComponent>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return controlSettingsUtils.getPrintDraftSaleReceipt();
                            }}
                            revertValue={()=>
                            {
                                controlSettingsUtils.setPrintDraftSaleReceipt(!controlSettingsUtils.getPrintDraftSaleReceipt());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("draft_sale_receipt_print")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("selecting_this_option_will_allow_the_system_to_print_a_draft_sales")
                            }}>

                        </CheckBoxComponent>
                    </div>

                </div>
    }

}


const mapStateToProps = state => 
{
    return { 
                settingsChangedTimeStamp: state.settingsChangedTimeStamp,
           }
}

export default connect(mapStateToProps)(ControlSettingsView)